customElements.define("x-user-upload", class FileUpload extends HTMLElement {

  constructor() {
    super();
    this._accept = null;
  }

  get accept() { return this._accept; }
  set accept(accept) {
    this._accept = accept; 
    if (!this._input) return;
    if (accept) {
      this._input.setAttribute("accept", accept);
    } else {
      this._input.removeAttribute("accept");
    }
  }

  connectedCallback() {
    this._shadowRoot = this.attachShadow({ mode: "closed", });

    this._div = document.createElement("div");
    this._div.style.position = "relative";

    this._input = document.createElement("input");
    this._input.setAttribute("type", "file");
    if (this._accept) this._input.setAttribute("accept", this._accept);
    this._input.addEventListener("change", this.handleChange.bind(this));
    this._input.style.position = "absolute";
    this._input.style.inset = "0 0 0 0";
    this._input.style.display = "none";

    this._slot = document.createElement("slot");
    this._slot.name = "root";
    this._slot.style.display = "block";
    this._slot.addEventListener("click", this.handleClick.bind(this));
    this._slot.addEventListener("keypress", this.handleKeypress.bind(this));

    this._div.appendChild(this._input);
    this._div.appendChild(this._slot);

    this._shadowRoot.appendChild(this._div);
  }

  async handleChange(event) {
    const file = this._input.files[0];
    const reader = new FileReader();
    const dataURL = await (new Promise((resolve, reject) => {
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    }));
    const detail = {
      lastModified: file.lastModified,
      name: file.name,
      size: file.size,
      type: file.type,
      dataURL,
    };
    this.dispatchEvent(new CustomEvent("filereplaced", {
      detail,
      bubbles: true,
      composed: true,
    }));
  }

  async handleFocus(event) {
    this._input.click();
  }

  async handleClick(event) {
    this._input.click();
  }

  async handleKeypress(event) {
    if ((event.key !== "Enter") && (event.key !== " ")) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    };
    await this._input.click();
    event.preventDefault();
  }
});
